import Avatar from "@components/avatar";
import axios from "axios";
import classnames from "classnames";
import React, { Fragment, useState } from "react";
import { Bell } from "react-feather";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useMutation } from "react-query";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { REST_API_WORKSUITE_V3 } from "../../../../constants";
import OverdueTasks from "./Notification/OverdueTasks";
import UncompletedMilestone from "./Notification/UncompletedMilestone";
import "./style.css";

const user = JSON.parse(localStorage.getItem("userData"));
const token = `Bearer ${user?.data?.token}`;
const token_company = localStorage?.getItem("token_company");

const PillFilled = ({ data, queryClient }) => {
  const [active, setActive] = useState("1");

  const toggle = (tab) => {
    setActive(tab);
  };
  
  return (
    <div className="notifications-pill">
      <Nav fill>
        <NavItem>
          <NavLink
            active={active === "3"}
            onClick={() => {
              toggle("3");
            }}
          >
            Activities
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === "1"}
            onClick={() => {
              toggle("1");
            }}
          >
            Tasks
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === "2"}
            onClick={() => {
              toggle("2");
            }}
          >
            Milestones
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent className="py-50" activeTab={active}>
        <TabPane tabId="3">
          <PerfectScrollbar
            component="li"
            className="media-list scrollable-container"
            options={{
              wheelPropagation: false,
            }}
          >
            <RenderNotificationItems data={data} queryClient={queryClient} />
          </PerfectScrollbar>
        </TabPane>
        <TabPane tabId="1">
          <OverdueTasks />
        </TabPane>
        <TabPane tabId="2">
          <UncompletedMilestone />
        </TabPane>
      </TabContent>
    </div>
  );
};
export default PillFilled;
const images = [
  {
    img: "https://erp.cloodo.com/user-uploads/photos/f1fbbbe9adc954510c2b88a9fe976357.png",
  },
  {
    img: "https://erp.cloodo.com/user-uploads/photos/f1fbbbe9adc954510c2b88a9fe976357.png",
  },
  {
    img: "https://erp.cloodo.com/user-uploads/photos/f1fbbbe9adc954510c2b88a9fe976357.png",
  },
  {
    img: "https://erp.cloodo.com/user-uploads/photos/f1fbbbe9adc954510c2b88a9fe976357.png",
  },
  {
    img: "https://erp.cloodo.com/user-uploads/photos/f1fbbbe9adc954510c2b88a9fe976357.png",
  },
  {
    img: "https://erp.cloodo.com/user-uploads/photos/f1fbbbe9adc954510c2b88a9fe976357.png",
  },
];

const RenderNotificationItems = ({ data, queryClient }) => {
  const img = images.map((itemImage) => itemImage.img);

  const useReadNotification = () => {
    const request = async (id) => {
      const config = {
        url: `${REST_API_WORKSUITE_V3}notifications/${id}`,
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
          "X-WorkSuite-Company-Token": token_company,
        },
      };
      return await axios(config);
    };
    return useMutation(request);
  };

  const { mutate: postForm } = useReadNotification();
  const handleReadNotification = async (id) => {
    postForm(id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["listNotifications"]);
      },
    });
  };

  return (
    <>
      {data &&
        data?.data?.map((it, index) => {
          const data_notification = it?.data_items;
          return (
            <div
              key={index + 1}
              style={{
                background:
                  it?.read_at === null ? "rgb(236, 240, 249)" : "#fff",
              }}
              className="border-bottom mb-2 background-notification"
            >
              <a
                key={index}
                className="d-flex"
                href={data_notification?.url}
                target="blank"
                onClick={() => handleReadNotification(it?.id)}
              >
                <div
                  className={classnames("list-item d-flex notification-common")}
                >
                  <Fragment>
                    <div className="me-1">
                      <Avatar img={img[index]} />
                    </div>
                    <div className="list-item-body flex-grow-1">
                      {data_notification?.message_name} {it?.read_at === null && <Bell size={15} color="#FF9F43" />}
                      <br />
                      <small
                        className="notification-text"
                        style={{ color: "#7D7B89" }}
                      >
                        {data_notification?.description}
                      </small>
                    </div>
                  </Fragment>
                </div>
              </a>
            </div>
          );
        })}
    </>
  );
};
